import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {InjectedRouter} from 'react-router';
import {Link} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {AffinityLogo} from '../HomePage/AffinityLogo';
import {CampusSlider} from '../Components/CampusSlider';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFooter} from '../Components/CampusFooter';
import {CampusFeedback} from '../FlatPages/CampusFeedback';
import {WhyUs} from '../Components/WhyUs';
import { ResolveUrl } from '../tgccGlobal';
import { CampusCustomerContent } from '../Components/CampusCustomerContent';
import { LeadForm } from '../Components/LeadForm';
import * as TgccRequest from '../tgccRequest';
import { MerchComponent } from '../Components/MerchComponent';




const homepageStyle : React.CSSProperties = {
    width:'100%',
}
const merchDiv: React.CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
    width:'1050px'
}
const merchWrapper: React.CSSProperties = {
    width:'100%',
    display:'flex',
    justifyContent:'center',
}
const schoolHdr: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    textAlign:'center',
    color:'rgb(97, 96, 96)',
    textTransform:'uppercase'
}

class Props extends Tgcc.BaseProps{
    ActiveProof: Tgcc.Proof;
}
type StateType = {
    Themes: Tgcc.MerchandisingTheme[];
}
const DIVISION: string = 'collegiate';
class _CampusMerch extends React.Component <Props, any > {
    state = {
        Themes:null
    }

    componentWillMount(){
        TgccRequest.getMerchandisingThemes(DIVISION,(themes: Tgcc.MerchandisingTheme[]) => this.loadThemes(themes))

    }

    loadThemes = (themes: Tgcc.MerchandisingTheme[]) => {
        this.setState({Themes:themes})
    }

    handleClick = (theme:Tgcc.MerchandisingTheme) => {
        browserHistory.push(Tgcc.Routes.CampusCollection(theme.theme))
    }
    getMerchThemes(){
        var themes = new Array()
        for (var i in this.state.Themes){
            var theme : Tgcc.MerchandisingTheme = this.state.Themes[i]
            themes.push(<MerchComponent key={i} theme={theme} onSelect={this.handleClick}></MerchComponent>)
        }
        return themes

    }
    render() {
        return (
                <div style={homepageStyle}>
                    <div id="homepage"></div>
                    <CampusHeader />
                    <CampusFeedback state={this.props.state} />
                    <h1 style={schoolHdr} className="shopSchool">Shop Your School</h1>
                    <div style={merchWrapper}>
                        <div style={merchDiv}>
                            {this.getMerchThemes()}               
                        </div>
                    </div>
                    <CampusFooter state={this.props.state} />
                </div>
        );
    }
}


var radiumCampusMerch = Radium(_CampusMerch);

const mapStateToProps = (state: Tgcc.GlobalState) => { 
    return { state:state}
};
export var CampusMerch = connect(mapStateToProps)(radiumCampusMerch);



